export enum ERoutePathParams {
  Counterparty = ':counterparty',
  Branch = ':branch',
  Customer = ':customer',
  Employee = ':employee',
  Account = ':account',
  Payment = ':payment',
  Type = ':type',
  ReconRecord = ':recon_record',
  Status = ':status',
}
